import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './locale'
import 'aos/dist/aos.css'

createApp(App).use(router).use(ElementPlus).use(i18n).mount('#app')
